import { render, staticRenderFns } from "./Myclass.vue?vue&type=template&id=77652a3e&scoped=true"
import script from "./Myclass.vue?vue&type=script&lang=js"
export * from "./Myclass.vue?vue&type=script&lang=js"
import style0 from "./Myclass.vue?vue&type=style&index=0&id=77652a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77652a3e",
  null
  
)

export default component.exports